/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Codeeditor_Read_OnlyInputs */



/**
* | output |
* | --- |
* | "Read Only" |
*
* @param {Spaces_Codeeditor_Read_OnlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_codeeditor_read_only = /** @type {((inputs?: Spaces_Codeeditor_Read_OnlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Codeeditor_Read_OnlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur-Lesen")
	return /** @type {LocalizedString} */ ("Read Only")
});